import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import rootReducer from '../redux/reducers'
import { authApi } from '../api/auth/AuthApi'
import { apiService } from '../api/apiService'

export const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(sagaMiddleware)
      .concat(apiService.middleware)
      .concat(authApi.middleware),
})
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof rootReducer>
// export type RootState = ReturnType<typeof store.getState>
export default store
